export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11156.bb2b4ac8.jpg";